export const nudgeReasonReceivedToday = "Dcb";
export const nudgeReasonReceivedOneDayAgo = "Ecb";
export const nudgeReasonReceivedDaysAgo = "Fcb";
export const nudgeReasonSentToday = "Gcb";
export const nudgeReasonSentOneDayAgo = "Hcb";
export const nudgeReasonSentDaysAgo = "Icb";
export default {nudgeReasonReceivedToday,nudgeReasonReceivedOneDayAgo,nudgeReasonReceivedDaysAgo,nudgeReasonSentToday,nudgeReasonSentOneDayAgo,nudgeReasonSentDaysAgo};